import React, { Component } from 'react';
import './Main.css';
import { Redirect, Route, Switch } from 'react-router-dom';
import Login from '../client/login/Login';
import { PrivateRoute } from '../shared/PrivateRoute';
import lazyComponent from '../shared/lazy-component';

// Everything except the login screen is split into its own chunk and downloaded when the route is first visited.
const UserInvitationsContainer = lazyComponent(() =>
  import('../client/user-invitations/UserInvitationsContainer')
);
const SetPassword = lazyComponent(() =>
  import('../client/user-invitations/SetPassword')
);
const Admin = lazyComponent(() => import('../admin/Admin'));
const RecoverPassword = lazyComponent(() =>
  import('../client/recover/RecoverPassword')
);
const ResetPassword = lazyComponent(() =>
  import('../client/recover/ResetPassword')
);
const RegisterUser = lazyComponent(() =>
  import('../client/register/RegisterUser')
);
const OrderMaterialsReview = lazyComponent(() =>
  import('../order-materials/Review')
);
const PublicRfaSigning = lazyComponent(() =>
  import('../public/PublicRfaSigning')
);

class Main extends Component {
  render() {
    return (
      <div className="main">
        <Switch>
          <Route path="/login" component={Login} />

          <Route path="/set-password" component={SetPassword} />

          <Route path="/recover-password" component={RecoverPassword} />
          <Route path="/reset-password" component={ResetPassword} />
          <Route path="/register" component={RegisterUser} />
          <Route
            path="/order-materials/review/:projectId/:token"
            component={OrderMaterialsReview}
          />

          <PrivateRoute path="/admin" component={Admin} />
          <PrivateRoute
            path="/user-invitations"
            component={UserInvitationsContainer}
          />
          <Route path="/public/rfa/:token" component={PublicRfaSigning} />
          <Redirect from="/" to="/admin" />
          <Redirect from="/index.html" to="/admin" />
        </Switch>
      </div>
    );
  }
}

export default Main;
